// removed by extract-text-webpack-plugin
module.exports = {"NumberStats":"NumberStats__NumberStats__1Dx-z","Small":"NumberStats__Small__3Rl5W"};